import { messages } from './AttachmentsSection.messages';

export const ocrButtonProps = { children: messages.uploadOcrButton, color: 'mint80' } as const;
